import { render, staticRenderFns } from "./groupMange.vue?vue&type=template&id=0e83bbba&scoped=true&"
import script from "./groupMange.vue?vue&type=script&lang=js&"
export * from "./groupMange.vue?vue&type=script&lang=js&"
import style0 from "./groupMange.vue?vue&type=style&index=0&id=0e83bbba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e83bbba",
  null
  
)

export default component.exports